<section>
  <ion-button fill="clear" class="border-border background-info" (click)="decrement()" [disabled]="disabled || value <= min">
    <b class="minus">-</b>
    <p *ngIf="step !== 1">{{ step }}</p>
  </ion-button>

  <input
    type="number"
    [value]="value"
    [disabled]="disabled"
    (change)="onInputChange($event)"
    [min]="min"
    [max]="max"
    [required]="true"
    (blur)="onBlur($event)"
    class="border-border form-control"
  >

  <ion-button fill="clear" class="border-border background-info" (click)="increment()" [disabled]="disabled || value >= max">
    <b>+</b>
    <p *ngIf="step !== 1">{{ step }}</p>
  </ion-button>
</section>
